import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';
import { formatCost, CONTEXTUAL_ENTITY_TYPE } from '@bingads-webui-campaign/recommendation-core';
import { withContextualAttributeTemplate } from '@bingads-webui-campaign/recommendation-contextual-attribute';

import template from './budget-delta.pug';

export class BudgetDeltaColumn extends ProjectionGridBaseColumn {
  constructor({ i18n, isMCC }) {
    super({
      name: 'BudgetDelta',
      property: 'Opportunities/SuggestedBudget',
      // [TODO] delete it
      title: i18n.getString('ColumnName_WhatYouCanDo') || '__what you can do__',
      bodyClasses: ['grid-column-BudgetDelta'],
      colClasses: ['col-superLongText'],
      sortable: false,
    });
    this.i18n = i18n;
    this.isMCC = isMCC;
  }

  template({
    value: {
      EstimatedIncreaseInBudget,
      OpportunityId,
      CurrentBudget,
      Target: {
        CampaignName,
        CampaignId,
        AccountName,
        AccountId,
      },
    },
  }) {
    const { i18n } = this;
    return template({
      entityName: withContextualAttributeTemplate({
        opportunityId: OpportunityId,
        entityName: CampaignName,
        entityId: CampaignId,
        entityType: CONTEXTUAL_ENTITY_TYPE.CAMPAIGN,
        status: 'false',
        ariaLabel: i18n.getString('Click to scope to campaign {{campaignName}}', { campaignName: CampaignName }),
      }),
      accountName: withContextualAttributeTemplate({
        opportunityId: OpportunityId,
        entityName: AccountName,
        entityId: AccountId,
        entityType: CONTEXTUAL_ENTITY_TYPE.ACCOUNT,
        status: 'false',
      }),
      fromVal: formatCost(CurrentBudget, i18n, i18n.currency),
      toVal: formatCost(CurrentBudget + EstimatedIncreaseInBudget, i18n, i18n.currency),
      i18n,
      isMCC: this.isMCC,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
